export default "__VITE_ASSET__COR8qWVk__"